import React, { useState } from 'react';

import Spinner from '../../components/ui/spinner';
import { useAppSelector } from '../../store';
import AsideMenu from './AsideMenu';

const ReportsAsideMenu = () => {
    const { momentReportsMenuList } = useAppSelector(state => state.momentReports);
    const [activeMenuType, setActiveMenuType] = useState<number>(0);

    const handleMenuType = (type: number) => {
        if (type < 2) setActiveMenuType(type)
    }

    return (
        <div className="col-01">
            {momentReportsMenuList?.loading && <Spinner type="02" />}
            {!momentReportsMenuList?.loading &&
                momentReportsMenuList?.items?.map((item, index) =>
                    <div onClick={() => handleMenuType(item?.reportMenuType)} key={'aside-menu-' + index}>
                        <AsideMenu item={item} activeMenuType={activeMenuType} setActiveMenuType={setActiveMenuType} />
                    </div>
                )}
        </div>
    );
};

export default ReportsAsideMenu;
